import { render, staticRenderFns } from "./TodoTaskForm.vue?vue&type=template&id=6ba2f0e2&"
import script from "./TodoTaskForm.vue?vue&type=script&lang=js&"
export * from "./TodoTaskForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ba2f0e2')) {
      api.createRecord('6ba2f0e2', component.options)
    } else {
      api.reload('6ba2f0e2', component.options)
    }
    module.hot.accept("./TodoTaskForm.vue?vue&type=template&id=6ba2f0e2&", function () {
      api.rerender('6ba2f0e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/eletronicSigned/modules/TodoTaskForm.vue"
export default component.exports